import React, { ReactNode } from 'react';

import { Ingredient, type IngredientProps } from './components/Ingredient';
import { IngredientInfoTags } from './content/ingredients-info';
import { CtaButton, CtaButtonProps } from 'components/global/CtaButton';
import { IngredientsInfoContent } from 'components/modules/Ingredients';
import { ReactComponent as Checkmark } from './images/checkmark.svg';
import {
  Disclaimer,
  IngredientBox,
  IngredientContainer,
  InnerBox,
  TextBox,
  TextBoxBody,
  TextBoxBodyContent,
  TextBoxHeader,
  desktopCtaStyles,
  mobileCtaStyles,
} from './IngredientsPop.style';
import { LOCAL_COLORS } from 'styles/constants';

export interface IngredientsInfoPopContent extends IngredientsInfoContent {
  shortName?: string;
  tags?: IngredientInfoTags[];
  introText?: string;
}

export interface IngredientsPopProps {
  header?: string;
  body?: ReactNode;
  ingredients: IngredientProps[];
  ctaButton?: CtaButtonProps;
  disclaimerText?: ReactNode;
  backgroundColor?: string;
  addCheckmark?: boolean;
}

const moduleName = 'ingredientsPop';

export const IngredientsPop = ({
  header,
  body,
  ingredients,
  ctaButton,
  disclaimerText,
  backgroundColor = LOCAL_COLORS.surfaceWhite,
  addCheckmark = false,
}: IngredientsPopProps) => {
  return (
    <IngredientContainer
      data-module={moduleName}
      backgroundColor={backgroundColor}
    >
      <InnerBox>
        <TextBox>
          {header && <TextBoxHeader>{header}</TextBoxHeader>}
          <TextBoxBody>
            {body && (
              <TextBoxBodyContent>
                {addCheckmark && <Checkmark />}
                {body}
              </TextBoxBodyContent>
            )}
            {ctaButton && <CtaButton {...ctaButton} css={desktopCtaStyles} />}
          </TextBoxBody>
        </TextBox>
        <IngredientBox size={ingredients.length}>
          {ingredients.map((ingredient) => (
            <Ingredient key={ingredient.title} {...ingredient} />
          ))}
        </IngredientBox>
        {disclaimerText && <Disclaimer>{disclaimerText}</Disclaimer>}
        {ctaButton && <CtaButton css={mobileCtaStyles} {...ctaButton} />}
      </InnerBox>
    </IngredientContainer>
  );
};
